import Client from '../client';
import { AxiosResponse } from 'axios';
import BaseService from '../baseService/baseService';

const ClusterService = 
{
    deletarExcelParametros(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'cluster/excel/deletar', 'excelClusterDeletar');
    },
    clusterExcelPost(fileRequest: any)
    {
        return BaseService.conectarEndpoint(fileRequest, 'cluster/excel', 'excelCluster');
    },
    obterExcel(): Promise<void | AxiosResponse<any>> 
    {
        return Client.getBlob('cluster/excel');
    },
    enviarParametrosAoEventGrid(): Promise<void | AxiosResponse<any>> 
    {
        return Client.post('cluster/eventGrid', {});
    }
}

export default ClusterService;